export default "__VITE_ASSET__DNKzX8RX__"